import React from 'react';
import {Button,Grid, Icon, Image, Segment} from 'semantic-ui-react';
import {DragSource, DropTarget} from 'react-dnd';
import {Link} from 'react-router-dom';
import {FormattedNumber} from 'react-intl';

import {makeDBContentImageUrl} from "utils/DBUtils";

/*
  Returns info from the object being dragged that
  will be passed as the targetItem when dropped
*/
const breakBeingDragged = {
  beginDrag(props) {
    return {
      id: props.id,
      challengeId: props.challengeId,
      index: props.index,
      cardImageId: props.imageId,
      permalink: props.permalink,
      title: props.title,
      starts: props.starts,
      completes: props.completes
    };
  }
};

/*
  Fires when a featured break is dropped onto a target.  Calls the
  onDropped method to notify the parent so it can update the order.
*/
const breakDroppedOn = {
  drop(props, monitor) {
    props.onDropped( props, monitor.getItem() );
  }
}

/**
 * Specifies the props to inject into your component.
 */
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

function targetThing(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

/*
  Represents a single row in the Featured Break Manager.
*/
class FeaturedBreak extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    // Need to extract out certain variables from props for react-dnd
    const { isDragging, isOver, connectDragSource, connectDropTarget, challengeId } = this.props;
    const opacity = isDragging ? 0 : 1; // We change the opacity fo the item to be zero when dragged so the user sees it is changing position

    // Return a connected component where it is both a drag source and drop target since
    // we are dragging and dropping the same item types.
    return connectDragSource(connectDropTarget(
      <div style={{ opacity }} className="featured-manager-row">
        { /* Spacer to show where you are dragging and move other items */}
        {isOver ?
          <div  style={{'height': '50px'}}></div>
        : ""}
        <Segment>
          <Grid columns="equal">
            <Grid.Row>
            <Grid.Column width={1} className="drag-controller">
              <Icon name="move"/>
            </Grid.Column>
            <Grid.Column width={2} className="featured-image">
              <Image src={makeDBContentImageUrl(this.props.imageId)}/>
            </Grid.Column>
            <Grid.Column width={10}>
              <Link to={`/break/${challengeId}/edit`}>{this.props.title ? this.props.title : this.props.permalink}</Link>
              <br/>
              <span>
                Starts: <FormattedNumber value={this.props.starts} />
                <br/>
                Completes: <FormattedNumber value={this.props.completes} />
              </span>
              <br/>
              { this.props.starts ? <span>Completion Rate: {Math.round( ((this.props.completes / this.props.starts)*100) * 10 ) / 10}% </span> : "" }
            </Grid.Column>
            <Grid.Column width={3} className="delete-button">
              <Button onClick={() => this.props.deleteItem(this.props.id)}>
                <Icon name="close"/>
              </Button>
            </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    ));
  }

}

// Export this as a DragSource and DropTarget since we are reordering the same item type.
export default DragSource("FEATURED_BREAK", breakBeingDragged, collect)(DropTarget("FEATURED_BREAK",breakDroppedOn,targetThing)(FeaturedBreak));



// WEBPACK FOOTER //
// ./public/pages/FeaturedManager/FeaturedBreak.jsx